<div class="main-content">
  <section class="featured-contracts">
    <div class="container mt2">
      <div class="row pt1">
        <div class="col-md-12 w-100 mxw-100">
          <div class="top-line" *ngIf="featured?.specialty?.id">
            <h5 class="header">
              Featured {{featured.specialty.name}} contracts
            </h5>
            <a [routerLink]="['/specialty', featured.specialty.id]">
              View All {{featured?.specialty?.name}} Contracts
            </a>
          </div>
          <items-slider
            [items]="slider_items"
            [index]="slider_index"
            itemWidthPercent="20"
          ></items-slider>
        </div>

        <div
          class="exclusive-contracts-container col-md-12"
          *ngIf="session?.user?.theme_id==2"
        >
          <div class="top-line">
            <h5 class="header">Exclusive AMP Contracts</h5>
          </div>

          <ul class="exclusive-contracts">
            <li class="item" routerLink="/contract/2">
              <div class="img-holder">
                <img
                  src="//ampurchasing.s3.amazonaws.com/img/amp-medpro.png"
                  alt=""
                />
              </div>
              <div class="item-info">
                <h3 class="subheader">Access MedPro Disposal contract</h3>
              </div>
            </li>

            <li class="item" routerLink="/contract/3">
              <div class="img-holder">
                <img
                  src="//ampurchasing.s3.amazonaws.com/img/amp-cpmedical.png"
                  alt=""
                />
              </div>
              <div class="item-info">
                <h3 class="subheader">Access CP Medical contract</h3>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>
